// extracted by mini-css-extract-plugin
export default {"headerWrapper":"MainLayout_headerWrapper__t4nU6"};